import { render, staticRenderFns } from "./parkmains.vue?vue&type=template&id=48c12a84&scoped=true&"
import script from "./parkmains.vue?vue&type=script&lang=js&"
export * from "./parkmains.vue?vue&type=script&lang=js&"
import style0 from "./parkmains.vue?vue&type=style&index=0&id=48c12a84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c12a84",
  null
  
)

export default component.exports